// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D57W","type":"styles_type__33E83","choices":"styles_choices__h6hke"};